import { ajaxPostJson } from './ajax';

// 检测记忆库文件是否合格
export const checkMemoryFileContent = (params) => {
  return ajaxPostJson(`/memory/checkFileContent`, params);
};

// 上传记忆库
export const addTransMemoryLib = (params) => {
  params.dataType = 'trans_domain'
  return ajaxPostJson(`/memory/addTransMemoryLib`, params);
};

// 检测术语库文件是否合格
export const checkTermFileContent = (params) => {
  return ajaxPostJson(`/term/checkFileContent`, params);
};

// 上传术语库
export const addTransTermLib = (params) => {
  params.dataType = 'trans_domain'
  return ajaxPostJson(`/term/addTransTermLib`, params);
};

// 获取创建断句规则中能选择的语种
export const queryAllExistLang = (params) => {
  return ajaxPostJson(`/transSegmentRule/queryAllExistLang`, params);
};

// 获取系统下拉的语种
export const queryAllLang = (params) => {
  return ajaxPostJson(`/common/queryAllLang`, params);
};

// 添加断句规则
export const insertPunctuateRule = (params) => {
  return ajaxPostJson(`/transSegmentRule/insert`, params);
};

// 删除断句规则
export const deletePunctuateRule = (params) => {
  return ajaxPostJson(`/transSegmentRule/delete`, params);
};

// 编辑断句规则
export const updateRuleName = (params) => {
  return ajaxPostJson(`/transSegmentRule/updateRuleName`, params);
};

// 断句规则效果预览
export const testRule = (params) => {
  return ajaxPostJson(`/transSegmentRule/test`, params);
};

// 配置断句规则
export const updateRule = (params) => {
  return ajaxPostJson(`/transSegmentRule/update`, params);
};